import React from "react";
import dayjs from "dayjs";
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";


// 
// 
const CustomDatePicker = (props) => {

    const nodeSelect = React.useRef(null);
    const [ isOpen, setIsOpen ] = React.useState(false)
    const current = props.defaultValue


    //
    //
    const handleClickSelect = async(e) => {
        if (nodeSelect.current.contains(e.target)) {
            return;
        }
        if(isOpen){
            setIsOpen(false);
        }
    };


    // 
    // 
    const _onChange = (value) => {
        if(props.onChange){
            props.onChange(value)
        }
        setIsOpen(!isOpen)
    }


    //
    //
    React.useEffect(() => {
        document.addEventListener("mousedown", handleClickSelect);
        return () => {
            document.removeEventListener("mousedown", handleClickSelect);
        };
    });


    // 
    // 
    return(
        <div className={`_select ${isOpen ? 'active' : ''}`} ref={nodeSelect}>

            <button className="" onClick={()=> setIsOpen(!isOpen)}>
                {current ? 
                    <span className="line-clamp-1">{dayjs(current).format('MM/DD/YYYY')}</span>
                : 
                    <div>Select date</div>
                }
                <span className="material-symbols-outlined">date_range</span>
            </button>

            <div className="_dd _datePicker">
                <DatePicker
                    selected={current}
                    onChange={_onChange}
                    inline
                    minDate={dayjs().toDate()}
                />
            </div>

        </div>
    )

}

export default CustomDatePicker